export default __webpack_public_path__ + "static/media/gartengestaltung-1.e86fd022.jpeg";